import React from "react";
import styles from "./styles.module.scss";
import { IconSidebar } from "./components/IconSidebar";
import { BottomNav } from "./components/BottomNav";

export { ListSidebar } from "./components/ListSidebar";

interface MainLayoutProps {
	children?: React.ReactNode;
	sidebar?: React.ReactNode;
	style?: React.CSSProperties;
	contentStyle?: React.CSSProperties;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children, sidebar, style, contentStyle }) => {
	return (
		<div
			className={styles.layout}
			style={style}
		>
			<IconSidebar />
			<main
				className={styles.mainContent}
				style={contentStyle}
			>
				{sidebar && <aside className={styles.listSidebar}>{sidebar}</aside>}
				<div className={styles.content}>
					{children ? (
						children
					) : (
						<div className={styles.emptyState}>
							<span className={styles.blurText}>Sem conteúdo</span>
						</div>
					)}
				</div>
			</main>
			<BottomNav />
		</div>
	);
};
